import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { organizeNumberOfStops } from './flight-option.config';
@Component({
  selector: 'tic-flight-option',
  templateUrl: './flight-option.component.html',
  styleUrls: ['./flight-option.component.scss']
})
export class FlightOptionComponent {

 [x: string]: any;
 @Input() flightLeg: any;
 @Input() parseDuration!: Function;
 @Input() parseLocation!: Function;
 @Input() inbound: any;
 @Input() outbound: any;

 @ViewChild('toggle') tooltipElement: ElementRef;
 @ViewChild('accrd') accrd: ElementRef;

 readonly organizeNumberOfStops = organizeNumberOfStops;  
  
  toggleClassToClosestParent() {
    const element = this.tooltipElement.nativeElement;
    const element2 = this.accrd.nativeElement;
     element.classList.toggle('open');
     element2.classList.toggle('open');
  }

  getTimeFromDate(dateTimeString:string){
      const date = new Date(dateTimeString);
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      return `${formattedHours}:${formattedMinutes}`;
    }

  getDayMonthYear(dateTimeString:string){
      const date = new Date(dateTimeString);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const dayOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()];
  return `${dayOfWeek}, ${day} ${month} ${year}`;
    }

  extractDurationComponents(durationString) {
  const regex = /P(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?/;

  const match = regex.exec(durationString);

  if (match) {
    const days = match[1] ? parseInt(match[1]) : 0;
    const hours = match[2] ? parseInt(match[2]) : 0;
    const minutes = match[3] ? parseInt(match[3]) : 0;

    return `${days}d ${hours}h ${minutes}m`;
  } else {
    throw new Error("Invalid duration format");
  } 
  }

  checkType(value:any){
    if (typeof value === 'object') {
      return true;
    } else {
      return false;
    }
  }

  getStopsTooltipText(segments) {
    if( segments.length > 1 ) {
      let stopsText = '';
      for (let i = 0; i < segments.length; i++) {
           
          if (segments[i].connectionTime) {
            stopsText = this.parseDuration(segments[i].connectionTime) + ' - ';
          }
          stopsText += segments[i].destination.name + '\n';;
      }
      return stopsText;
    }
    return null;
  }

  convertToAmPm(time: string): string {
    if (!time) return ''; // Handle empty values
    const [hour, minute] = time.split(':').map(Number);
    const suffix = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour % 12 || 12; // Convert 0 to 12 for AM
    return `${formattedHour}:${minute.toString().padStart(2, '0')} ${suffix}`;
  }
}
